import { Component, Input, ChangeDetectorRef } from '@angular/core';
import * as jQuery from 'jquery';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { PrerollCreativeV3Component } from './../preroll-creative-v3/preroll-creative-v3.component';

@Component({
	selector: 'app-preroll-creative-v4',
	templateUrl: './preroll-creative-v4.component.html',
	styleUrls: ['./preroll-creative-v4.component.css']
})
export class PrerollCreativeV4Component extends PrerollCreativeV3Component {
	@Input() downloadconfig: any;
	public downloadConfiguration: any;
	public isR4: boolean = false;
	@Input() sectiontitle: string;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		super(analyticsService, analyticsDataModel, cdr);
	}

	ngOnInit() {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.isR4 = this.analyticsDataModel.config.version === 'R4' ? true : false;
		super.ngOnInit();
	}

	// To update the campaign index on dropdown selection

	updateCampaign(index) {
		this.setDisplayIndexContent(index);
		jQuery('.creative_mask').show();
		jQuery('#preRollvideo')[0].currentTime = 0;
		jQuery('#preRollvideo')[0].play();
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = true;
			jQuery('#percent25, #percent50, #percent75, #percent100').css('opacity', 0.5);
		}
	}
	playclickEvent() {
		jQuery('#preRollvideo')[0].play();
		if (jQuery('#preRollvideo')[0].currentTime == 0) {
			jQuery('#percent25, #percent50, #percent75, #percent100').css('opacity', 0.5);
		}
	}

	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.downloadFileName,
			this.downloadCSVColumns
		);
	}
}
